import {SavingsCalculatorDealBrand, WeeklyBudget} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"

import savingsCalculatorDealBrandList, {savingsCalculatorDealBrandListQueryKey} from "./services/queries/savingsCalculatorDealBrands"
import weeklyBudget, {weeklyBudgetQueryKey} from "./services/queries/weeklyBudget"

export const useSavingsCalculatorDealBrandList = createUseQuery<SavingsCalculatorDealBrand, {}>(savingsCalculatorDealBrandList, {
  key: savingsCalculatorDealBrandListQueryKey
})

export const useWeeklyBudget = createUseQuery<WeeklyBudget, {}>(weeklyBudget, {
  key: weeklyBudgetQueryKey
})

